// The InternalApi's SignalR hub. Kiota generates only the REST surface, so this piece of the contract
// is written by hand. It mirrors Application/Common/Models/CallAnsweredNotification.cs and
// Infrastructure/SignalR (NotificationHub.Path, SignalRNotificationService.CallAnsweredMethod); the
// functional NotificationHubTests pin the server side.
export const NOTIFICATION_HUB_PATH = '/hubs/notifications';
export const CALL_ANSWERED = 'callAnswered';
// SignalRNotificationService.CallsChangedMethod: the call list changed; no payload
export const CALLS_CHANGED = 'callsChanged';
// NotificationHub.RefusedWithoutEmail: the close reason when the account has no e-mail claim
export const REFUSED_WITHOUT_EMAIL = 'refused: the signed-in account has no e-mail claim';

export interface CallAnsweredNotification {
    callId: string;
    customerId: string | null;
    phoneNumber: string | null;
}
